import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      toast.success("If that email is registered, a reset link is on its way.");
    } catch (error) {
      toast.error(formatApiErrorDetail(error.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return <AuthCard title="Reset your password" subtitle="Enter your email and we'll send you a secure reset link.">
    <form onSubmit={submit} className="space-y-4">
      <Input label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
      <button disabled={loading} className="w-full bg-zinc-900 text-white py-2.5 rounded-lg font-medium disabled:opacity-60">{loading ? "Sending…" : "Send reset link"}</button>
    </form>
    <BackToLogin />
  </AuthCard>;
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const token = params.get("token") || "";

  const submit = async (event) => {
    event.preventDefault();
    if (!token) return toast.error("This reset link is invalid or incomplete.");
    if (password !== confirm) return toast.error("Passwords do not match.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. You can now sign in.");
    } catch (error) {
      toast.error(formatApiErrorDetail(error.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return <AuthCard title="Choose a new password" subtitle="Use at least 8 characters.">
    <form onSubmit={submit} className="space-y-4">
      <Input label="New password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} minLength="8" required />
      <Input label="Confirm password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} minLength="8" required />
      <button disabled={loading} className="w-full bg-zinc-900 text-white py-2.5 rounded-lg font-medium disabled:opacity-60">{loading ? "Updating…" : "Update password"}</button>
    </form>
    <BackToLogin />
  </AuthCard>;
}

function AuthCard({ title, subtitle, children }) {
  return <div className="min-h-screen grid place-items-center p-6 bg-zinc-50"><div className="w-full max-w-sm bg-white border border-zinc-200 rounded-xl p-7 shadow-sm"><h1 className="font-display text-2xl font-semibold">{title}</h1><p className="text-sm text-zinc-500 mt-1 mb-7">{subtitle}</p>{children}</div></div>;
}
function Input({ label, ...props }) { return <label className="block"><span className="text-xs font-semibold uppercase tracking-[.08em] text-zinc-500">{label}</span><input {...props} className="mt-1.5 w-full border border-zinc-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-zinc-900" /></label>; }
function BackToLogin() { return <p className="mt-6 text-center text-sm text-zinc-500"><Link to="/login" className="text-zinc-900 font-medium hover:underline">Back to sign in</Link></p>; }
